// extracted by mini-css-extract-plugin
export var legendIndicator = "_fl-1";
export var legendRight = "_fl-0";